import { useAtomValue } from "jotai";

import { orgsAtom } from "~/atoms";
import { Org } from "~/utils/Types";
import * as orgRole from "~/utils/orgRole";

export const useOrgs = () => {
  const orgs = useAtomValue(orgsAtom);

  const currentOrg = orgs?.find && orgs.find((i) => i?.isCurrent);

  return {
    currentOrg,
    getOrgLocation: (org?: Org) => orgRole.getOrgLocation(org ?? currentOrg),
    getOrgShortName: (org?: Org) => orgRole.getOrgShortName(org ?? currentOrg),
    isAllLocations: (org?: Org) => orgRole.isAllLocations(org ?? currentOrg),
    isDemoUsa: (org?: Org) => orgRole.isDemoUsa(org ?? currentOrg),
    isHarmony: (org?: Org) => orgRole.isHarmony(org ?? currentOrg),
    isJbsBrazil: (org?: Org) => orgRole.isJbsBrazil(org ?? currentOrg),
    orgs,
  };
};
